import { render } from "./AdministrativeData.vue?vue&type=template&id=c74f075e&scoped=true&ts=true"
import script from "./AdministrativeData.vue?vue&type=script&lang=ts"
export * from "./AdministrativeData.vue?vue&type=script&lang=ts"

import "./AdministrativeData.vue?vue&type=style&index=0&id=c74f075e&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c74f075e"]])

export default __exports__